<script lang="ts">
	import type { PromoPage } from "$lib/def/seo/page";

	import Meta from "$lib/ui/shared/seo/Meta.svelte";
	import AppDownload from "$lib/ui/home/seo/AppDownload.svelte";
	import SeoAreaSelector from "$lib/ui/home/seo/SeoAreaSelector.svelte";
	import SeoBusinessInfo from "$lib/ui/home/seo/SeoBusinessInfo.svelte";
	import SeoFooter from "$lib/ui/home/seo/SeoFooter.svelte";
	import SeoHeader from "$lib/ui/home/seo/SeoHeader.svelte";
	import SeoBusinessInfoItem from "$lib/ui/shared/seo/SeoBusinessInfoItem.svelte";
	import SeoIntroDetail from "$lib/ui/shared/seo/SeoIntroDetail.svelte";

	import { selectAddress } from "$lib/ui/modals/AddressModal.svelte";

	export let data: any;
	let pageData = data.page as PromoPage;
</script>

<svelte:head>
	<Meta meta={data.meta} />
	{#if data.canonical}
		<link rel="canonical" href={data.canonical} />
	{/if}
</svelte:head>

<SeoHeader 
	image={pageData?.banner?.name} 
	title={pageData.heading} 
	subtitle={pageData.searchPrompt}/>
	<!-- copy={data.header?.callToAction} -->

<SeoIntroDetail 
	image={pageData.background} 
	title={pageData.subtitle} 
	subtitle={pageData.description}
	cta={{
		text: pageData.callToAction ?? '', 
		action: pageData.callToActionTarget ? pageData.callToActionTarget : () => selectAddress(false), 
		newTab: true
	}}/>
	<!-- TODO: @Michiel: NB! the 'cta' prop's action is set to 'callToActionTarget' if there is one, 
	 but if not, I need to convert it, so that it can detect if its a string value or a specific method,
	 
	PS: Ask Pieter if its always gonna be "Download the app!", cuz thats on the designs -->

<!-- App download -->
{#if data.apps.main}
	<div id="appdownload">
		<AppDownload main={data.apps.main} appstores={data.apps.stores} />
	</div>
{/if}

<SeoBusinessInfo>
	<SeoBusinessInfoItem item={data.biCorpLinks[0]} cta={{text: 'Get started', action: '/about/become-a-partner'}} />
	<SeoBusinessInfoItem item={data.biCorpLinks[1]} cta={{text: 'Apply now', action: '/about/become-a-driver'}} />
	<SeoBusinessInfoItem item={data.biCorpLinks[2]} cta={{text: 'Apply now', action: '/about/careers'}} />
</SeoBusinessInfo>


<SeoAreaSelector areas={data.parentAreas} />

<!-- <SeoFooter appstores={data.apps.stores} socials={data.social} tallogo={data.tallogo}/> -->